/**
 * represent the Discount with its code
 */
const DiscountService = function ($sce, $filter, $timeout) {

  return {
    item: null,
    code: '',
    showInfo: false,
    error: {
      discountInfoLink: '',
      discountInfoData: ''
    },

    resetItem: function () {
      this.item = null;
      this.code = '';
    },
    setItem: function (item) {
      this.item = item;
      this.code = item.identifier;
    },

    /**
     * @return {*}
     */
    getInfoLink: function () {
      return $sce.trustAsHtml(
              '<span class="tw-inline-flex tw-h-6 tw-w-6 tw-align-middle tw-items-center tw-justify-center"><button type="button" onclick="discount_modal.showModal()" aria-label="' + this.error.discountInfoLink + '" class="modalTrigger discount tw-btn tw-btn-circle tw-btn-ghost tw-btn-xs !tw-grid !tw-h-6 !tw-min-h-6 !tw-w-6 !tw-place-items-center !tw-p-0 !tw-leading-none hover:tw-text-black"><span class="icon icon-info !tw-m-0 !tw-grid !tw-h-6 !tw-w-6 !tw-place-items-center !tw-leading-none" aria-hidden="true"></span></button></span>'
      );
    },

    setError: function (item) {
      this.error.discountInfoLink = item.discountInfoLink;
      this.error.discountInfoData = item.discountInfoData;
    },

    /**
     * @param $scope
     * @param item
     */
    setDiscount: function (item, $scope) {
      if (!item.identifier || item.error) {
        if (item.error) {
          var error = item.error;
          this.error.discountInfoLink = '';
          this.error.discountInfoData = '';
          if (item.discountInfoLink) {
            this.setError(item);
            error += ' ' + this.getInfoLink();
          }
          $scope.displayError(error);
        }
        this.resetItem();
        if ($scope.cartItems) {
          delete $scope.cartItems[ 'product' + '-' + item.id ];
        }
        return;
      }

      this.setItem(item);

      item.productid = item.id;
      $scope.cartItems[ 'product' + '-' + item.id ] = item;

      $scope.showVoucherForm = false;

      $scope.clearDiscountAppliedLiveMessage();
      $timeout(function () {
        const prefix = $scope.translations['custom']['checkout_cart_discount_applied'];
        $scope.setDiscountAppliedLiveMessage(prefix + ' ' + $filter('currency')(item.price));
      }, 150);

      $scope.scrollCartToBottom();
      $scope.updateCartSum();

    }
  };
};


export default DiscountService;
